export const environment = {
    alias: 'memowl-beta',
    firebaseProject: 'memowl-version-2',
    sentryDsn:
        'https://240ccf4b35ffe1e330b008adb5d3db51@o4508794559070208.ingest.de.sentry.io/4508794607894608',
};
